import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {ProfileService} from '../services/profile.service'
import { EmployerRecord } from '../models/employer.model';
import {Registration} from '../models/registration.model';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'edit-employeeDialog',
    templateUrl: './editVerifierList.component.html',
})
export class EditVerifierListDialogComponent {
    UserRecord:Registration = new Registration();
    public GetCompanyName ;

    constructor( public dialogRef: MatDialogRef<EditVerifierListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef,private ProfileService:ProfileService) {
            if (this.data.newObj != null){ 
                this.UserRecord = this.data.newObj
                // this.employeeRecord.HireDt = this.employeeRecord.HireDt.transform(this.employeeRecord.HireDt, 'dd-MM-yy');
                
                
            }
            this.ProfileService.GetCompanyName().subscribe(res => this.GetCompanyNameSucess(res), res => this.GetCompanyNameError(res));
            console.log(data);
            dialogRef.disableClose = true;
    }
    
    ngOnInit(){
        
    }

    GetCompanyNameSucess(res){
        this.GetCompanyName = res.json();
    }

    GetCompanyNameError(res){}

    onNoClick(): void {
        this.dialogRef.close();
    }

    UpdateVerifierRecord(){
        this.ProfileService.UpdateVerifierDetails(this.UserRecord).subscribe(res => this.UpdateVerifierDetailsSucess(res), res => this.UpdateVerifierDetailsError(res));
    };

    UpdateVerifierDetailsSucess(res){
        this.dialogRef.close();
    }

    UpdateVerifierDetailsError(res){}


}